module.exports = __webpack_public_path__ + "img/MailboxShell.77453386.svg";